/**
 * The source recorded on the prescription's distributed order item (CY-353), shared by the reports
 * column and by the mutator that stores it on the sequence.
 */
export function getProductionSource(sequence) {
    const item = sequence.order?.distributedOrders?.orders?.find(order => order.sequenceId === sequence.id);
    if (!item)
        return null;
    const hasNewPack = (item.activeSubstances?.batches?.length ?? 0) > 0;
    const hasRestVial = (item.restVials?.length ?? 0) > 0;
    if (hasNewPack && hasRestVial)
        return 'both';
    if (hasRestVial)
        return 'rest_vial';
    if (hasNewPack)
        return 'new_pack';
    return null;
}
//# sourceMappingURL=production-source.js.map